var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tpl-detail"},[_c('h5',{staticClass:"row"},[_c('span',{staticClass:"tit fl"},[_vm._v(_vm._s(_vm.titName))]),_c('div',{staticClass:"right-box"},[_vm._t("titRight")],2)]),_c('div',{staticClass:"content"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }